module.exports = __webpack_public_path__ + "img/skating_baltic.d50bb815.jpg";